import PropTypes from 'prop-types';
import React from "react";
import RightSide from "./RightSide";
import LeftSide from "./LeftSide";
import Header from "./Header";

const Main = ({ mainRef }) => (
  <div className="section__main">
    <Header />
    <main role="main" className="Content" ref={mainRef}>
      <div className="ContentRow">
        <LeftSide />
        <RightSide />
      </div>
    </main>
  </div>
);

Main.propTypes = {
  mainRef: PropTypes.func.isRequired,
};

export default Main;



// WEBPACK FOOTER //
// ./src/pages/Main/Main.js